import React from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import FloatButton from "../components/utils/FloatButton";
import Seo from "../components/Seo";
import Product from "../components/ProductPage/Product";
import ContactBanner from "../components/common/ContactBanner";

const ProductPage = () => {
  return (
    <div className="w-full">
      <Seo
        title={"Produk OLIN"}
        description={
          "Temukan solusi kelola apotek secara digital dengan software apotek dari OLIN. Optimalkan opearsional apotek serta monitoring bisnis Anda secara real-time"
        }
        name={"OLIN"}
        canonLink={"https://olin.co.id/product"}
      />
      <div className="sticky top-0 bg-white z-30 shadow-lg">
        <Navbar />
      </div>
      <div className="relative">
        <div className="fixed bottom-6 right-3 z-30">
          <FloatButton />
        </div>
      </div>

      <Product />
      <Footer />
    </div>
  );
};

export default ProductPage;
